import { ExpandableItem, Item, Token, useToggle } from '@revolut-internal/ui-kit'
import { FC, PropsWithChildren } from 'react'

interface CollapsibleSectionProps extends PropsWithChildren {
  name: string
  initialOpen?: boolean
}

export const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  name,
  children,
  initialOpen = false,
}) => {
  const [isExpanded, expandedToggle] = useToggle({
    defaultState: initialOpen,
  })

  return (
    <ExpandableItem
      data-testid={name}
      expanded={isExpanded}
      onToggle={expandedToggle.switch}
    >
      <ExpandableItem.Content>
        <ExpandableItem.Title variant="emphasis2">{name}</ExpandableItem.Title>
      </ExpandableItem.Content>
      <ExpandableItem.NestedContent style={{ margin: Token.space.s12 }}>
        <Item p="s-12">
          <Item.Content>{children}</Item.Content>
        </Item>
      </ExpandableItem.NestedContent>
    </ExpandableItem>
  )
}
